<template>
  <div class="flex flex-col">
    <div class="overflow-x-auto">
      <div class="inline-block w-full py-2 align-middle">
        <h1
          class="text-ontick-steel-900 py-2 text-lg font-medium dark:text-gray-300"
        >
          {{ title }}
        </h1>

        <div
          class="border-ontick-steel-300 dark:border-ontick-steel-600 overflow-hidden border-b shadow sm:rounded-lg"
        >
          <table
            class="divide-ontick-steel-300 dark:divide-ontick-steel-600 min-w-full divide-y"
          >
            <thead class="bg-ontick-steel-100 dark:bg-ontick-steel-600">
              <tr>
                <th
                  v-for="(item, index) in header"
                  :key="index"
                  scope="col"
                  class="title_th"
                >
                  <button
                    class="flex h-full w-full items-center gap-1 py-2 px-3 text-left font-bold"
                    @click="sort(item.key)"
                  >
                    <span v-if="item.key === sortKey">
                      {{ sortIcon }}
                    </span>
                    <p>
                      {{ item.label }}
                    </p>
                  </button>
                </th>
              </tr>
            </thead>

            <transition-group
              v-on:enter="enter"
              v-on:leave="leave"
              v-bind:css="false"
              appear
              mode="out-in"
              tag="tbody"
              class="divide-ontick-steel-300 dark:divide-ontick-steel-600 dark:bg-ontick-graphite-500 divide-y bg-gray-50"
            >
              <tr
                class="dark:bg-ontick-graphite-500 bg-gray-50"
                v-for="(item, index) in sortedData"
                :key="index"
              >
                <td class="td-items">
                  {{ item.order_symbol }}
                </td>
                <td class="td-items">
                  {{ item.strategy_name }}
                </td>
                <td class="td-items">
                  {{ item.order_time | moment("DD/MM/YYYY HH:mm:ss:SSS") }}
                </td>

                <td class="td-items">
                  <span
                    class="rounded px-2"
                    :class="badgerStatus(item.order_state)"
                    :content="textTooltip(item.order_state)"
                    v-tippy="{ arrow: true, theme: 'green' }"
                  >
                    {{ item.order_state }}</span
                  >
                </td>

                <td class="td-items">
                  {{ item.order_goal }}
                </td>
                <td class="td-items">
                  {{ item.order_direction }}
                </td>

                <td class="td-items">
                  <span
                    class="bg-ontick-prussian-400 text-ontick-prussian-50 rounded px-2"
                    :content="textOrder(item.order_type)"
                    v-tippy="{ arrow: true, theme: 'green' }"
                  >
                    {{ item.order_type }}
                  </span>
                </td>

                <td class="td-items">
                  {{ item.order_volume }}
                </td>
                <td class="td-items">
                  {{ item.order_price }}
                </td>
                <td class="td-items">
                  {{ item.order_comment }}
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition";

export default {
  props: {
    data: { type: Object, default: {} },

    title: { type: String, default: "Titulo" },
  },
  components: {
    CollapseTransition,
  },

  data() {
    return {
      header: [
        { label: "Ativo", key: "order_symbol" },
        { label: "Estratégia", key: "strategy_name" },
        { label: "Horário", key: "order_time" },
        { label: "Status", key: "order_state" },
        { label: "Sentido", key: "order_goal" },
        { label: "Tipo", key: "order_direction" },
        { label: "Ordem", key: "order_type" },
        { label: "Volume", key: "order_volume" },
        { label: "Preço", key: "order_price" },
        { label: "Comentário", key: "order_comment" },
      ],
      toogle: [],
      sortDirection: "",
      sortKey: "",
    };
  },

  computed: {
    sortIcon() {
      const directions = {
        asc: "▲",
        desc: "▼",
      };
      return directions[this.sortDirection] || "";
    },
    sortedData() {
      switch (this.sortDirection) {
        case "asc":
          return this.data.investments.sort((a, b) => {
            if (a[this.sortKey] < b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] > b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        case "desc":
          return this.data.investments.sort((a, b) => {
            if (a[this.sortKey] > b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] < b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        default:
          return this.data.investments;
      }
    },
  },

  methods: {
    sort(key) {
      if (key) {
        if (this.sortKey === key) {
          this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
        } else {
          this.sortDirection = "asc";
        }
        this.sortKey = key;
      }
    },
    enter(el, done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      tl.set(el, {
        x: window.innerWidth * 1.5,
        scale: 0.9,
        transformOrigin: "50% 50%",
      });

      tl.to(el, 0.5, {
        x: 0,
        ease: Power4.easeOut,
      });

      tl.to(el, 0.5, {
        scale: 1,
        ease: Power4.easeOut,
      });
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    textOrder(value) {
      let text = "";

      if (value == "L") {
        text = "Limite";
      } else if (value == "T") {
        text = "Stop limite";
      }

      return text;
    },

    textTooltip(value) {
      let text = "";
      if (value == "C") {
        text = "Cancelada";
      } else if (value == "F") {
        text = "Executada";
      } else if (value == "R") {
        text = "Rejeitada";
      } else if (value == "T") {
        text = "Parcial";
      } else if (value == "E") {
        text = "Expirada";
      } else if (value == "Z") {
        text = "Congelada";
      } else if (value == "S") {
        text = "Iniciada";
      } else if (value == "P") {
        text = "Colocada ";
      }
      return text;
    },

    badgerStatus(value) {
      let color = "";
      if (value == "P") {
        color = "bg-ontick-blue-800 text-ontick-blue-200";
      } else if (value == "F") {
        color = "bg-ontick-lime-900 text-ontick-lime-400";
      } else if (value == "S") {
        color = "bg-ontick-teal-600 text-ontick text-ontick-teal-50";
      } else if (value == "W") {
        color = "bg-gray-600 text-gray-300";
      } else if (value == "C") {
        color = "bg-ontick-orange-900 text-ontick-orange-300";
      } else if (value == "R") {
        color = "bg-ontick-red-900 text-ontick-red-300";
      } else if (value == "E") {
        color = "bg-ontick-pink-900 text-ontick-link-300";
      } else if (value == "T") {
        color = "bg-ontick-yellow-800 text-ontick-yellow-50";
      }
      return color;
    },

    showInvestmentPortfolio(inv) {
      const index = this.toogle.indexOf(inv);
      if (index > -1) {
        this.toogle.splice(index, 1);
      } else {
        this.toogle.push(inv);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title_th {
  @apply text-ontick-carbon-900 text-center text-sm font-bold dark:text-gray-300;
}
.td-items {
  @apply text-ontick-carbon-900 whitespace-nowrap px-3 py-3 text-left text-xs dark:text-gray-300;
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 300ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}
</style>
